import PropTypes from 'prop-types'
import styles from './fechaSelect.module.css'

export const FechaSelect = ({
  label,
  claveFecha,
  errorFecha,
  fecha,
  guardarFecha,
  errorMensaje
}) => {
  return (
    <div className={styles.fechaContainer}>
      <label htmlFor="fecha">{`Fecha de ${label}`}</label>
      <input
        type="date"
        id="fecha"
        className={errorFecha ? styles.inputError : ''}
        value={fecha || ''}
        onChange={(e) => guardarFecha(e.target.value, claveFecha || label)}
      />
      {errorFecha && (
        <span className={styles.mensajeError}>
          {errorMensaje || 'La fecha no es válida.'}
        </span>
      )}
    </div>
  )
}

FechaSelect.propTypes = {
  label: PropTypes.string.isRequired,
  claveFecha: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errorFecha: PropTypes.bool,
  fecha: PropTypes.string,
  guardarFecha: PropTypes.func.isRequired,
  errorMensaje: PropTypes.string
}
